import { EntityTypes } from "../../EntityTypes";
import { ISkillLevelResource } from "../../skill-levels";
import { ITopicWork } from "../../topics/types";
import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue, mapRelationalValue, mapRelationalValueAsIRI } from "../../utils/filters";
import { IWorkResource } from "../../works";

export interface IWorkUpdateMutationParameters {
    work: RelationalValue<IWorkResource>;
    trainerComment?: string;
    validatedSkillLevels?: RelationalValue<ISkillLevelResource>[];
    unvalidatedSkillLevels?: RelationalValue<ISkillLevelResource>[];
}

export type IWorkUpdateMutationResult = ITopicWork;

export const workUpdateMutation: IApiMutationFunction<IWorkUpdateMutationParameters> = ({
    work,
    trainerComment,
    validatedSkillLevels,
    unvalidatedSkillLevels,
}) => {
    return {
        method: "PUT",
        url: `/works/${mapRelationalValue(work)}`,
        data: {
            trainerComment,
            validatedSkillLevels: validatedSkillLevels?.map(
                skillLevel => mapRelationalValueAsIRI(EntityTypes.SKILL_LEVEL, skillLevel) ?? [],
            ),
            unvalidatedSkillLevels: unvalidatedSkillLevels?.map(
                skillLevel => mapRelationalValueAsIRI(EntityTypes.SKILL_LEVEL, skillLevel) ?? [],
            ),
        },
    };
};

export const useWorkUpdateMutation = createApiMutationHook<IWorkUpdateMutationParameters, IWorkUpdateMutationResult>(
    workUpdateMutation,
);
